import React from 'react';
import styled from 'styled-components';
import { mobileMediaQuery } from '../../../Theming';
import { SvgProps } from '../core';

const StyledSVG = styled.svg`
  ${mobileMediaQuery} {
    margin-left: 25px;
    width: 105.16px;
    height: 112.19px;
  }
`;

const HowItworksDesktop: React.FC<SvgProps> = ({
  width = 156,
  height = 159,
  className,
}) => {
  return (
    <StyledSVG
      width={width}
      height={height}
      className={className}
      viewBox="0 0 134 138"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M51.7725 124.2V110.401H24.3636C21.1641 110.401 17.9959 109.687 15.0399 108.3C12.0839 106.913 9.3981 104.88 7.13573 102.317C4.87335 99.7536 3.07875 96.7109 1.8544 93.3623C0.630052 90.0136 -7.52956e-05 86.4245 6.74836e-09 82.8V27.6C6.74836e-09 20.28 2.56687 13.2599 7.13593 8.08385C11.705 2.90785 17.902 7.64481e-09 24.3636 7.6448e-09H109.636C112.835 -8.52977e-05 116.004 0.713747 118.96 2.10074C121.916 3.48773 124.601 5.52072 126.864 8.08362C129.126 10.6465 130.921 13.6892 132.145 17.0378C133.37 20.3864 134 23.9755 134 27.6V82.8C134 86.4246 133.37 90.0137 132.146 93.3624C130.921 96.7111 129.126 99.7538 126.864 102.317C124.602 104.88 121.916 106.913 118.96 108.3C116.004 109.687 112.835 110.401 109.636 110.401H82.2269V124.2H97.4543C99.0698 124.2 100.619 124.927 101.761 126.221C102.904 127.515 103.545 129.27 103.545 131.1C103.545 132.93 102.904 134.685 101.761 135.979C100.619 137.273 99.0698 138 97.4543 138H36.5457C34.9302 138 33.3809 137.273 32.2386 135.979C31.0964 134.685 30.4546 132.93 30.4546 131.1C30.4546 129.27 31.0964 127.515 32.2386 126.221C33.3809 124.927 34.9302 124.2 36.5457 124.2H51.7725ZM24.3636 13.8003C21.1329 13.8005 18.0346 15.2544 15.7501 17.8423C13.4657 20.4303 12.1822 23.9401 12.1821 27.6V82.8C12.1821 86.4601 13.4655 89.9702 15.7501 92.5583C18.0347 95.1464 21.1333 96.6003 24.3642 96.6003H109.636C112.867 96.6003 115.965 95.1464 118.25 92.5583C120.534 89.9702 121.818 86.4601 121.818 82.8V27.6C121.818 23.94 120.534 20.43 118.25 17.8421C115.965 15.2542 112.867 13.8003 109.636 13.8003H24.3636ZM63.9546 124.2H70.0454V110.401H63.9546V124.2Z"
        fill="#1B2457"
      />
    </StyledSVG>
  );
};

export default HowItworksDesktop;
